import i18n from '@/i18n';
import Storage from '@/modules/storage';
import CountryCodes from '@/lib/CountryCodes';

const DEFAULT_COUNTRY_CODE_MAP = {
  'zh-tw': 212,
  zh: 212,
  'zh-cn': 43,
  cn: 43,
  'en-us': 230,
  en: 230,
  fr: 72,
  ja: 106,
  de: 78,
  es: 203,
};

const getCountryCode = () =>
  Storage.getCountryCode() || CountryCodes[DEFAULT_COUNTRY_CODE_MAP[i18n.locale] || 0];

const handlePhoneInput = {
  data: () => ({
    showCountryCode: false,
    localNumber: '',
    countryCode: getCountryCode(),
  }),
  methods: {
    openCountryCode() {
      this.showCountryCode = true;
    },
    closeCountryCode() {
      this.showCountryCode = false;
    },
    setLocalPhone(phone) {
      if (!phone) {
        this.countryCode = getCountryCode();
        return;
      }

      for (const c of CountryCodes) { // eslint-disable-line
        if (phone.indexOf(c.value) === 0) {
          this.countryCode = c;
          this.localNumber = phone.replace(c.value, '');
          break;
        }
      }
    },
  },
  computed: {
    phoneNumber() {
      let phoneNumber = this.localNumber;
      if (phoneNumber.indexOf('0') === 0) {
        phoneNumber = phoneNumber.substring(1);
      }
      return `${this.countryCode.value}${phoneNumber}`;
    },
  },
};

export default handlePhoneInput;
